import axios from "../axios-instance";
import {
  MyProfile_START,
  MyProfile_ERROR,
  MyProfile_SUCCESS,
  IsDataSubmitedSuccessfully,
} from "../constants/myProfile";
import {
  buildProfileUpdateFormData,
  parseProfileUpdateResponse,
} from "../utils/profileImage";
import { setCurrentUser } from "./authActions";

/**
 * Get User details
 * @param {*} options
 * @returns
 */
export const getUserProfileData = (options) => async (dispatch) => {
  const { onSuccess, onError } = options || {};
  axios
    .get("user-details")
    .then((res) => {
      const profile = res?.data?.data ?? res?.data;
      if (onSuccess) {
        onSuccess(profile);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * Get User details
 * @param {*} options
 * @returns
 */
export const updateUserProfileData = (options) => async (dispatch) => {
  const { data, onSuccess, onError } = options || {};

  const formData = buildProfileUpdateFormData(data);

  axios
    .post("user/edit", formData)
    .then((res) => {
      const { jwtClaims, user } = parseProfileUpdateResponse(res?.data);

      if (jwtClaims && user) {
        const imageVersion = Date.now();
        const userWithVersion = {
          ...user,
          profile_image_version: imageVersion,
        };
        const storedClaims = {
          ...jwtClaims,
          user: userWithVersion,
        };

        localStorage.setItem("config", JSON.stringify(storedClaims));
        dispatch(setCurrentUser(userWithVersion));
      }

      if (onSuccess) {
        onSuccess(res.data, user);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

export const getMyProfileData = (id) => (dispatch) => {
  dispatch({
    type: MyProfile_START,
  });
  axios
    .get("user-details/" + id)
    .then((res) => {
      axios
        .get("company-settings-services")
        .then((countryRes) => {
          dispatch({
            type: MyProfile_SUCCESS,
            payload: res.data,
            countryDD: countryRes.data.data.countries,
          });
        })
        .catch((err) => {
          dispatch({
            type: MyProfile_ERROR,
            payload: err.response.data.data,
          });
        });
    })
    .catch((err) =>
      dispatch({
        type: MyProfile_ERROR,
        payload: err.response.data.data,
      })
    );
};

export const updateMyProfileData = (profileData) => (dispatch) => {
  dispatch({
    type: MyProfile_START,
  });
  axios
    .post("user/edit", profileData)
    .then((res) => {
      dispatch({
        type: IsDataSubmitedSuccessfully,
        IsDataSubmitedSuccessfully: true,
      });
      //  getMyProfileData(1)(dispatch);
    })
    .catch((err) =>
      dispatch({
        type: MyProfile_ERROR,
        payload: err.response.data.data,
      })
    );
};
